import React from 'react';
import { Container } from '../internals/Container';
export const PageSection = (props) => (React.createElement(Container, Object.assign({}, props, { tagName: "section" })));
//# sourceMappingURL=PageSection.js.map